// Generated from SVG to Code Figma Plugin

export const BaseLineIntelligentAspectRatio = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 12L20 18C20 19.6569 18.6569 21 17 21L7 21C5.34315 21 4 19.6569 4 18L4 6C4 4.34315 5.34315 3 7 3L13.2 3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M18.2734 2.28103C18.3272 1.90421 18.8712 1.90421 18.9251 2.28103C19.132 3.72931 20.2699 4.86724 21.7182 5.07414C22.095 5.12797 22.095 5.67203 21.7182 5.72586C20.2699 5.93276 19.132 7.07069 18.9251 8.51897C18.8712 8.89579 18.3272 8.89579 18.2734 8.51897C18.0665 7.07069 16.9285 5.93276 15.4803 5.72586C15.1034 5.67203 15.1034 5.12797 15.4803 5.07414C16.9285 4.86724 18.0665 3.72931 18.2734 2.28103Z"
      fill="currentColor"
    />
  </svg>
);
